import Vue from 'vue';
import Router from 'vue-router';

import PairingPage from './components/PairingPage.vue';
import ConnectingPage from './components/ConnectingPage.vue';
import PutIntoAPPairingModeInstructionsPage3Clicks from './components/shortcutInstructions/PutIntoAPPairingModeInstructionsPage3Clicks.vue';
import PutIntoAPPairingModeInstructionsPageWaitAP from './components/shortcutInstructions/PutIntoAPPairingModeInstructionsPageWaitAP.vue';
import LoadingPage from './components/LoadingPage.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Loading',
      component: LoadingPage,
    },
    {
      path: '/pairing',
      name: 'Pairing',
      component: PairingPage,
    },
    {
      path: '/instructions',
      name: 'Instructions',
      component: PutIntoAPPairingModeInstructionsPage3Clicks,
    },
    {
      path: '/instructions_waitap',
      name: 'Instructions_waitap',
      component: PutIntoAPPairingModeInstructionsPageWaitAP,
    },
    {
      path: '/connecting',
      name: 'Connecting',
      component: ConnectingPage,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router.ts